/* import __COLOCATED_TEMPLATE__ from './plus-tier-banner-market.hbs.js'; */
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import Component from '@glimmer/component';
import { Vertical } from '@dashboard/shared-ui/utils/vertical-configs';

/**
  Usage Example:

  <Upsell::PlusTierBannerMarket.js
    @vertical={{this.Vertical.RESTAURANTS}}
    @buttonClass="dummy__button--rst-orange dummy__button--market"
    @buttonClick={{action "popup"}}>

    <:header-image><SqIcon80CircleCircleArrowsPaperCheck/></:header-image>
    <:title>Reopen closed checks</:title>
    <:description>
      Need to reopen a check to make an adjustment, like comping or voiding an accidental item?
    </:description>
    <:button-text>Unlock with Plus</:button-text>
  </Upsell::PlusTierBannerMarket>

  @yields header-image - image to display in the header (on the top)
  @yields title - h3 title copy
  @yields description - description/paragraph copy
  @yields button-text - text to display in footer button
  @yields button-group - optional block to pass through a custom market-button-group

  @param {String} vertical - vertical using this upsell card
  @param {String} buttonClass - CSS class to apply to the button
  @param {Action} buttonAction - action to take when the button is clicked
  @param {String} classNames - CSS class(es) to apply to the market-content-card

*/
export default class PlusTierBannerMarket extends Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "Vertical", Vertical);
  }
}